import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  Media: {
    height: '100%',
    width: '100%',
  },

  '.MuiInputLabel-root': {
    color: 'red',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 50px)',
  },

  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: theme.palette.primary.dark,
  },

  insideH1: {
    marginBottom: 0,
    fontWeight: 'normal',
    fontSize: '32px',
    lineHeight: '40px',
  },

  rightWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },

  paperWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    width: '100%',
    height: '100%',
  },

  leftBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    padding: '30px',
    width: '530px',
    height: '100%',
    color: 'white',
    '& p': {
      marginBottom: '5px',
    },
  },

  loginImage: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: '20px',
  },

  logoImage: {
    width: '100%',
    height: '50px',
    marginLeft: 0,
    marginRight: 'auto',
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '600px',
  },

  checkEmailHeader: {
    fontSize: '36px',
    padding: '20px',
    marginTop: '80px',
  },

  checkEmailBody: {
    textAlign: 'center',
    width: '505px',
  },
}))

export { useStyles }
